module.exports = __webpack_public_path__ + "img/christian_wilkins.a7057847.png";